import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { callApp } from '@ifeng/callapp';
import style from './wakeApp.css';
import { isClient } from '../../utils/utils';

const WakeApp = function WakeApp(props) {
    const isCallup = props.devicetype !== 'pc' && !isClient();

    // 点击拉活
    const handleClick = function handleClick(event) {
        callApp({
            docType: 'channel',
            pid: 'feiyan',
            kind: 'share01',
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1453822808118',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8796',
        });
    };

    return isCallup ? (
        <div className={style.content}>
            <div className={style.box}>
                <button className={style.wakeBtn} type="button" onClick={handleClick}>
                    打开新闻客户端疫情频道
                </button>
            </div>
        </div>
    ) : null;
};

WakeApp.propTypes = {
    devicetype: PropTypes.string,
};

export default WakeApp;
